import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import styled, { ThemeProvider } from 'styled-components'
import Img from 'gatsby-image'
//import "../assets/styles/labs.scss";

import { Button } from '../components/button'
import { Footer } from '../components/footer'
import { Grid, Column } from '../components/grid'
import { Header, Accent } from '../components/header'
import { Hero } from '../components/hero'
import { LabsTheme } from '../components/theme'
import { Navbar } from '../components/navbar'
import { Segment } from '../components/segment'
import { Wrapper } from '../components/wrapper'
import { HDivider, VDivider } from '../components/divider'

import svgIcoMusic from '../assets/svg/Membran_Music.svg'
import svgIcoBusiness from '../assets/svg/Membran_Business.svg'
import svgIcoBlockchain from '../assets/svg/Membran_Blockchain.svg'
import svgIcoHarvest from '../assets/svg/Membran_Harvest.svg'
import svgIcoHyperstate from '../assets/svg/Membran_Hyperstate.svg'
import svgIcoTrebleKey from '../assets/svg/Membran_TrebleKey.svg'

const IndexPage = props => (
    <ThemeProvider theme={LabsTheme}>
        <Wrapper>
            <Helmet title='Home' />
            <Segment style={{ height: 0, padding: '0 0 0 0', margin: 0, zIndex: 999 }}>
                <Navbar fade>
                    <h2><a href='#top'><Accent>membran</Accent> labs</a></h2>
                    <a style={{ fontSize: '0.75em', fontWeight: 'bold' }} href='#services'>SERVICES</a>
                    <a style={{ fontSize: '0.75em', fontWeight: 'bold' }} href='#projects'>PROJECTS</a>
                    <a style={{ fontSize: '0.75em', fontWeight: 'bold' }} href='#about'>ABOUT US</a>
                </Navbar>
            </Segment>
            <div id='top' />
            <Hero dark centered >
                <Img
                    css={{ top: 0, left: 0, right: 0, zIndex: -1 }}
                    style={{ position: 'absolute' }}
                    title='Header image'
                    alt='computer workstation'
                    sizes={props.data.header.sizes}
                    className='background'
                />
                <div className='inner'>
                    <Grid>
                        <Column span='12'>
                            <h1 style={{ letterSpacing: 2, fontSize: '2.5em' }}>
                                <strong>
                                    M<Accent>U</Accent>SIC MEETS BL<Accent>O</Accent>CKCHAIN
                                </strong>
                            </h1>
                            <p style={{ fontWeight: '300' }}>
                                helping to usher music into the next digital age
                            </p>
                        </Column>
                    </Grid>
                </div >
            </Hero>

            <Segment centered>
                <div style={{
                    zIndex: 1,
                    position: 'absolute',
                    top: '0px',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    margin: 'auto',
                }}>
                    <VDivider style={{ top: '-50px' }} />
                </div>
                <Grid>
                    <Column span='12'>
                        <Header>
                            <h2 style={{ letterSpacing: 2 }}>MUSIC FIRST</h2>
                        </Header>
                    </Column>
                    <Column span='12'>
                        <h4 style={{ fontWeight: 500 }}>
                            <Accent>We are a music company with a tech team, <br /> not the other way around.</Accent>
                        </h4>
                        <p>
                            With extensive expertise in the music industry, we understand
                            the challenges and problems you face, because we face them too.
                            Our team is already researching, building, and testing a number of solutions to make it easier,
                            faster, and more efficient for you to get paid and rewarded for your music!
                    </p>
                    </Column>
                    <Column span='12'>
                        <p>
                            Whether you’re a performing artist or writer, a label or publisher,
                            a manager or promoter, or just interested in music and how blockchain technology
                            is likely to change everything; we are here to help educate, test, and
                            develop solutions with you.
                        </p>
                    </Column>
                </Grid>
            </Segment>

            <Segment centered>
                <div id='services' style={{ position: 'relative', top: '-100px' }} />
                <VDivider style={{ position: 'relative', top: '-50px' }} />
                <Grid>
                    <Column span='12'>
                        <Header>
                            <h2>SERVICES</h2>
                        </Header>
                    </Column>
                    <Column span='4'>
                        <img style={{ width: '50%', maxWidth: '200px' }} src={svgIcoMusic} />
                        <Header>
                            <h3 style={{ letterSpacing: '2.4' }}>MUSIC</h3>
                        </Header>
                        <p>Helping navigate the rapidly changing music industry</p>
                        <HDivider />
                        <p>Clarifying music rights, registrations, &amp; the flow of music revenues</p>
                        <HDivider />
                        <p>Providing access to global artist services</p>
                    </Column>
                    <Column span='4'>
                        <img style={{ width: '50%', maxWidth: '200px' }} src={svgIcoBusiness} />
                        <Header>
                            <h3 style={{ letterSpacing: '2.4' }}>BUSINESS</h3>
                        </Header>
                        <p>Insights for your business and the music industry</p>
                        <HDivider />
                        <p>Positioning you to take advantage of blockchain technology</p>
                        <HDivider />
                        <p>Building your release strategy and navigating the global music market</p>
                    </Column>
                    <Column span='4'>
                        <img style={{ width: '50%', maxWidth: '200px' }} src={svgIcoBlockchain} />
                        <Header>
                            <h3 style={{ letterSpacing: '2.4' }}>BLOCKCHAIN</h3>
                        </Header>
                        <p>Educating about blockchain and its use cases</p>
                        <HDivider />
                        <p>Giving you insights and turning your ideas into reality</p>
                        <HDivider />
                        <p>Developing real world projects</p>
                    </Column>
                </Grid>
            </Segment>

            <Segment centered dark style={{ height: 300 }}>
                <div id='contact' style={{ position: 'relative', top: '-100px' }} />
                <Img css={{ zIndex: -1 }}
                    style={{ position: 'absolute', objectFit: 'cover' }}
                    title='Background 01'
                    alt='computer workstation'
                    sizes={props.data.pic01.sizes}
                    className='background'
                />
                <div style={{ marginTop: 50, position: 'relative' }}>
                    <Grid>
                        <Column span='12'>
                            <a href='mailto://canada@membran.net' style={{ borderBottom: 'none', fontSize: '1em', fontWeight: '700', padding: 10 }} >
                                <Button inverse style={{ borderRadius: 0, borderWidth: 4, height: 65 }}>
                                    CONTACT US
                                </Button>
                            </a>
                        </Column>
                    </Grid>
                </div>
            </Segment>

            <Segment centered>
                <div id='projects' style={{ position: 'relative', top: '-100px' }} />
                <div style={{
                    zIndex: 1,
                    position: 'absolute',
                    top: '0px',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    margin: 'auto',
                }}>
                    <VDivider style={{ top: '-50px' }} />
                </div>
                <Grid style={{ paddingTop: 25 }}>
                    <Column span='12'>
                        <Header>
                            <h2>PROJECTS</h2>
                        </Header>
                    </Column>
                    <Column span='4'>
                        <img style={{ width: '50%', maxWidth: '200px' }} src={svgIcoTrebleKey} alt="treblekey icon" />
                        <Header>
                            <h3>
                                TREBLEKEY
                            </h3>
                        </Header>
                        <p>
                            An events management platform that gives control and clarity to
                            event creators and security to fans.
                        </p>

                        <a href='/treblekey#top' style={{ borderBottom: 'none', fontSize: '0.6em', fontWeight: '700', padding: 10 }} >
                            <Button style={{ borderRadius: 0, borderWidth: 4, height: 65 }}>
                                LEARN MORE
                            </Button>
                        </a>
                    </Column>

                    <Column span='4'>
                        <img style={{ width: '50%', maxWidth: '200px' }} src={svgIcoHyperstate} alt="hyperstate icon" />
                        <Header>
                            <h3>
                                HYPERSTATE
                            </h3>
                        </Header>
                        <p>
                            Generating instantaneous royalty reporting, from Spotify to the Artist,
                            and everyone in between, at the same time.
                        </p>
                        
                        <a href='/hyperstate#top' style={{ borderBottom: 'none', fontSize: '0.6em', fontWeight: '700', padding: 10 }} >
                            <Button style={{ borderRadius: 0, borderWidth: 4, height: 65 }}>
                                LEARN MORE
                            </Button>
                        </a>
                        
                    </Column>

                    <Column span='4'>
                        <img style={{ width: '50%', maxWidth: '200px' }} src={svgIcoHarvest} alt="harvest icon" />
                        <Header>
                            <h3>
                                HARVEST
                            </h3>
                        </Header>
                        <p>
                            "Air Miles for Artists". A fun way to reward artists based on
                            actual fan engagement, not based on the streaming provider, or
                            their contract split. Tradeable, collectable, and valuable.
                        </p>

                        <a href='/harvest#top' style={{ borderBottom: 'none', fontSize: '0.6em', fontWeight: '700', padding: 10 }} >
                            <Button style={{ borderRadius: 0, borderWidth: 4, height: 65 }}>
                                LEARN MORE
                            </Button>
                        </a>
                    </Column>
                </Grid>
            </Segment>

            <Segment centered>
                <div id='about' style={{ position: 'relative', top: '-100px' }} />
                <VDivider style={{ position: 'relative', top: '-50px' }} />
                <div className='inner'>
                    <Grid>
                        <Column span='12'>
                            <Header>
                                <h2>ABOUT US</h2>
                            </Header>
                        </Column>
                        <Column span='12'>
                            <p>
                                Membran Labs was born from the Membran Group of Companies, out of a
                                mutual concern for the current state of the music industry, and an
                                interest in the latest technologies that show promise to help
                                solve some of the most important problems.
                            </p>
                        </Column>
                    </Grid>
                </div>
            </Segment>
            <Footer dark>
                <div alt='This div is here for spacing.' />
                <div>
                    <ul style={{ listStyle: 'none', textAlign: 'center' }}>
                        <h2 style={{ textAlign: 'center' }}>CONTACT</h2>
                        <li><a href='mailto:canada@membran.net'>EMAIL US</a></li>
                    </ul>
                    <ul style={{ listStyle: 'none', textAlign: 'center' }}>
                        <h2 style={{ textAlign: 'center' }}>PODCAST</h2>
                        <li><a href='https://anchor.fm/fault-tolerant' target='_blank'>Fault Tolerant</a></li>
                        <li><a href='https://anchor.fm/offkey' target='_blank'>OffKey</a></li>
                        <li><a href='https://medium.com/membran-labs' target='_blank'>Show Notes</a></li>
                        <li><a href='/studio_rates.pdf' target='_blank'>Studio</a></li>
                    </ul>
                </div>

                <div>
                    <ul style={{ listStyle: 'none', textAlign: 'center' }}>
                        <h2 style={{ textAlign: 'center' }}>EXPLORE</h2>
                        <li><a href='http://www.membran.net'>MEMBRAN.NET</a></li>
                        <li><Accent>MEMBRAN LABS</Accent></li>
                        <li><a href='/treblekey'>TREBLEKEY</a></li>
                        <li><a href='harvest/'>HARVEST</a></li>
                        <li><a href='hyperstate/'>HYPERSTATE</a></li>
                    </ul>
                </div>


            </Footer>
        </Wrapper>
    </ThemeProvider>
)

export default IndexPage

export const pageQuery = graphql`
  query LabsHeaderImageQuery {
    header: imageSharp(id: { regex: "/labs_header/" }) {
      sizes(maxWidth: 4000, quality: 95 ) {
        ...GatsbyImageSharpSizes
      }
    },
    pic01: imageSharp(id: { regex: "/labs_01/" }) {
        sizes(maxWidth: 2000, quality: 90 ) {
            ...GatsbyImageSharpSizes
        }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js